import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Download, Eye } from "lucide-react";
import { G, download, errMsg } from "./guestApi";

export function ImportHistory({ session, center, refreshKey, onOpen }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.post(`${G}/import/history`, { token: session.token, center })
      .then((r) => setRows(r.data.rows || [])).catch((e) => toast.error(errMsg(e)));
  }, [session.token, center, refreshKey]);
  return (
    <div className="border rounded overflow-x-auto" data-testid="guest-import-history">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500"><tr>
          <th className="p-2">When</th><th className="p-2">Source</th><th className="p-2">By</th>
          <th className="p-2">Rows</th><th className="p-2">Status</th><th className="p-2">Result</th><th className="p-2" /></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={7} className="p-4 text-center text-slate-500">No imports yet.</td></tr>}
          {rows.map((b) => (
            <tr key={b.id} className="border-t" data-testid={`guest-history-row-${b.id}`}>
              <td className="p-2 text-xs">{(b.created_at || "").slice(0, 16).replace("T", " ")}</td>
              <td className="p-2 text-xs">{b.file_name}</td>
              <td className="p-2 text-xs">{b.created_by}</td>
              <td className="p-2 text-xs">{b.total_rows}</td>
              <td className="p-2"><Badge variant="outline">{b.status}</Badge></td>
              <td className="p-2 text-[11px] text-slate-600">
                {b.result ? Object.entries(b.result.counts).map(([k, n]) => `${k} ${n}`).join(" · ") : ""}</td>
              <td className="p-2 flex gap-1">
                {["REVIEW", "COMMITTED", "COMMIT_FAILED"].includes(b.status) && (
                  <Button size="sm" variant="ghost" onClick={() => onOpen(b.id)} data-testid={`guest-history-open-${b.id}`}>
                    <Eye className="w-3.5 h-3.5" /></Button>)}
                <Button size="sm" variant="ghost" data-testid={`guest-history-report-${b.id}`}
                  onClick={() => download(`${G}/import/error-report`, { token: session.token, batch_id: b.id },
                    `import_issues_${b.center}.xlsx`).catch((e) => toast.error(errMsg(e)))}>
                  <Download className="w-3.5 h-3.5" /></Button>
              </td>
            </tr>))}
        </tbody>
      </table>
    </div>
  );
}
